import middelware from "./middelware";

const routes = [
  {
    path: "/",
    component: () => import("@/views/layout/PageLayout"),
    children: [
      {
        path: "",
        component: () => import("@/views/pages/home/HomeView"),
      },
      {
        path: "user",
        component: () => import("@/views/pages/user/UserView"),
        redirect: "/user/login",
        children: [
          {
            path: "login",
            component: () => import("@/views/pages/user/login/LoginView"),
            beforeEnter: [middelware.anonymous, middelware.savePrevRoute],
          },
          {
            path: "signup",
            component: () => import("@/views/pages/user/signup/SignupView"),
            beforeEnter: middelware.anonymous,
          },
          {
            path: "mypage",
            component: () => import("@/views/pages/user/mypage/MypageView"),
            beforeEnter: middelware.authenticated,
          },
          {
            path: "sucession",
            component: () => import("@/views/pages/user/sucession/SucessionView"),
            beforeEnter: middelware.authenticated,
          },
          {
            path: "find",
            component: () => import("@/views/pages/user/find/FindView"),
            redirect: "/user/find/email",
            beforeEnter: middelware.anonymous,
            children: [
              {
                path: "email",
                component: () => import("@/views/pages/user/find/FindEmail"),
              },
              {
                path: "password",
                component: () => import("@/views/pages/user/find/FindPassword"),
              },
            ],
          },
        ]
      },
      {
        path: "policy",
        component: () => import("@/views/pages/policy/PolicyView"),
        redirect: "/policy/term",
        children: [
          {
            path: "term",
            component: () => import("@/views/pages/policy/TermView"),
          },
          {
            path: "privacy",
            component: () => import("@/views/pages/policy/PrivacyView"),
          },
        ]
      },
      {
        path: "counsel",
        component: () => import("@/views/pages/counsel/CounselView"),
        children: [
          {
            path: "",
            component: () => import("@/views/pages/counsel/CounselList"),
          },
          {
            path: "create",
            component: () => import("@/views/pages/counsel/CounselCreate"),
          },
          {
            path: ":counselId",
            component: () => import("@/views/pages/counsel/CounselDetail"),
          },
        ],
      },
      {
        path: "subject",
        component: () => import("@/views/pages/subject/SubjectView"),
        redirect: "/subject/subject1",
        children: [
          {
            path: "subject1",
            component: () => import("@/views/pages/subject/subject1/Subject1"),
            redirect: "/subject/subject1/cate1",
            children: [
              {
                path: "cate1",
                component: () => import("@/views/pages/subject/subject1/cate1/Cate1"),
              },
              {
                path: "cate2",
                component: () => import("@/views/pages/subject/subject1/cate2/Cate2"),
              },
            ],
          },
          {
            path: "subject2",
            component: () => import("@/views/pages/subject/subject2/Subject2"),
            redirect: "/subject/subject2/cate1",
            children: [
              {
                path: "cate1",
                component: () => import("@/views/pages/subject/subject2/cate1/Cate1"),
              },
              {
                path: "cate2",
                component: () => import("@/views/pages/subject/subject2/cate2/Cate2"),
              },
              {
                path: "cate3",
                component: () => import("@/views/pages/subject/subject2/cate3/Cate3"),
              },
              {
                path: "cate3/:beautyId",
                component: () => import("@/views/pages/subject/subject2/cate3/BeautyDetail"),
              }
            ],
          },
          {
            path: "subject3",
            component: () => import("@/views/pages/subject/subject3/Subject3"),
          },
          {
            path: "subject4",
            component: () => import("@/views/pages/subject/subject4/Subject4"),
          },
        ]
      },
      {
        path: "doctor",
        component: () => import("@/views/pages/doctor/DoctorView"),
      },
      {
        path: "lecture",
        component: () => import("@/views/pages/lecture/LectureView"),
        children: [
          {
            path: "",
            component: () => import("@/views/pages/lecture/LectureList"),
          },
          {
            path: ":lectureId",
            component: () => import("@/views/pages/lecture/LectureDetail"),
          },
        ],
      },
      {
        path: "guide",
        component: () => import("@/views/pages/guide/GuideView"),
        redirect: "/guide/intro",
        children: [
          {
            path: "intro",
            component: () => import("@/views/pages/guide/intro/IntroView"),
          },
          {
            path: "review",
            component: () => import("@/views/pages/guide/review/ReviewView"),
            children: [
              {
                path: "",
                component: () => import("@/views/pages/guide/review/ReviewList"),
              },
              {
                path: "create",
                component: () => import("@/views/pages/guide/review/ReviewCreate"),
                beforeEnter: middelware.authenticated,
              },
              {
                path: ":reviewId",
                component: () => import("@/views/pages/guide/review/ReviewDetail"),
                beforeEnter: middelware.authenticated,
              },
            ],
          },
          {
            path: "b4a",
            component: () => import("@/views/pages/guide/b4a/B4AView"),
            children: [
              {
                path: "",
                component: () => import("@/views/pages/guide/b4a/B4AList"),
              },
              {
                path: ":b4aId",
                component: () => import("@/views/pages/guide/b4a/B4ADetail"),
                beforeEnter: middelware.authenticated,
              },
            ],
          },
        ],
      },
      {
        path: "404",
        component: () => import("@/views/pages/404/NotFound.vue"),
        meta: {
          title: "404"
        },
      },
      {
        path: ":pathMatch(.*)*",
        redirect: "404",
      },
    ],
  },
];

export default routes;
